import React, { lazy } from 'react';

const Hero404Page = lazy(() => import('./Hero404Page'));
const HeroAboutPage = lazy(() => import('./HeroAboutPage'));
const HeroBlogPage = lazy(() => import('./HeroBlogPage'));
const HeroBookPage = lazy(() => import('./HeroBookPage'));
const HeroChecklistGenerator = lazy(() => import('./HeroChecklistGenerator'));
const HeroDemoPage = lazy(() => import('./HeroDemoPage'));
const HeroDownloadsPage = lazy(() => import('./HeroDownloadsPage'));
const HeroEventsListingPage = lazy(() => import('./HeroEventsListingPage'));
const HeroExtended = lazy(() => import('./HeroExtended'));
const HeroFreeTrialPage = lazy(() => import('./HeroFreeTrialPage'));
const Hero = lazy(() => import('./Hero'));
const HeroLearningCenterPage = lazy(() => import('./HeroLearningCenterPage'));
const HeroMaintenanceCalculatorsPage = lazy(() =>
  import('./HeroMaintenanceCalculatorsPage')
);
const HeroOpenAISearch = lazy(() => import('./HeroOpenAISearch'));
const HeroPartnershipsListing = lazy(() => import('./HeroPartnershipsListing'));
const HeroPodcastsListing = lazy(() => import('./HeroPodcastsListing'));
const HeroPressReleases = lazy(() => import('./HeroPressReleases'));
const HeroResourceHub = lazy(() => import('./HeroResourceHub'));
const HeroReviewsListingPage = lazy(() => import('./HeroReviewsListingPage'));
const HeroSimple = lazy(() => import('./HeroSimple'));
const HeroSlider = lazy(() => import('./HeroSlider'));
const HeroSupportPage = lazy(() => import('./HeroSupportPage'));
const HeroTemplatesPage = lazy(() => import('./HeroTemplatesPage'));
const HeroUpKeepPledge = lazy(() => import('./HeroUpKeepPledge'));
const HeroDemoCmmsRadio = lazy(() => import('./HeroDemoCmmsRadio'));
const HeroHomePage = lazy(() => import('./HeroHomePage'));
const HeroDemoGoogle = lazy(() => import('./HeroDemoGoogle'));
const HeroDemoBing = lazy(() => import('./HeroDemoBing'));
const HeroProductRelease = lazy(() => import('./HeroProductRelease'));
const HeroVideo = lazy(() => import('./HeroVideo'));

const HeroComponent = ({ component, pageMeta, location }) => {
  switch (component?.variant) {
    case 'extended':
      return <HeroExtended component={component} pageMeta={pageMeta} />;
    case 'book-page':
      return <HeroBookPage component={component} pageMeta={pageMeta} />;
    case 'about-page':
      return <HeroAboutPage component={component} pageMeta={pageMeta} />;
    case 'blog-listing':
      return <HeroBlogPage component={component} pageMeta={pageMeta} />;
    case 'resource-library':
      return <HeroResourceHub component={component} pageMeta={pageMeta} />;
    case 'events-listing':
      return (
        <HeroEventsListingPage component={component} pageMeta={pageMeta} />
      );
    case 'learning-listing':
      return (
        <HeroLearningCenterPage
          component={component}
          pageMeta={pageMeta}
          location={location}
        />
      );
    case 'support-page':
      return <HeroSupportPage component={component} pageMeta={pageMeta} />;
    case 'downloads-listing':
      return <HeroDownloadsPage component={component} pageMeta={pageMeta} />;
    case 'checklist-listing':
      return <HeroTemplatesPage component={component} pageMeta={pageMeta} />;
    case 'maintenance-calculators':
      return (
        <HeroMaintenanceCalculatorsPage
          pageMeta={pageMeta}
          component={component}
        />
      );
    case 'podcast-listing':
      return <HeroPodcastsListing pageMeta={pageMeta} component={component} />;
    case '404-page':
      return <Hero404Page component={component} pageMeta={pageMeta} />;
    case 'home-page':
      return <HeroHomePage component={component} location={location} />;
    case 'simple':
      return <HeroSimple component={component} pageMeta={pageMeta} />;
    case 'slider':
      return <HeroSlider component={component} pageMeta={pageMeta} />;
    case 'partnerships-listing':
      return (
        <HeroPartnershipsListing component={component} pageMeta={pageMeta} />
      );
    case 'demo-page':
      return <HeroDemoPage component={component} location={location} />;
    case 'free-trial-page':
      return <HeroFreeTrialPage component={component} location={location} />;
    case 'reviews-listing':
      return (
        <HeroReviewsListingPage component={component} pageMeta={pageMeta} />
      );
    case 'press-listing':
      return <HeroPressReleases component={component} pageMeta={pageMeta} />;
    case 'openai-search':
      return <HeroOpenAISearch component={component} />;
    case 'openai-checklist-generator':
      return <HeroChecklistGenerator component={component} />;
    case 'upkeep-pledge':
      return <HeroUpKeepPledge component={component} pageMeta={pageMeta} />;
    case 'demo-cmms-radio':
      return <HeroDemoCmmsRadio component={component} location={location} />;
    case 'demo-google':
      return <HeroDemoGoogle component={component} location={location} />;
    case 'demo-bing':
      return <HeroDemoBing component={component} location={location} />;
    case 'product-release':
      return <HeroProductRelease component={component} pageMeta={pageMeta} />;
    case 'video':
      return <HeroVideo component={component} location={location} />;
    default:
      return (
        <Hero component={component} pageMeta={pageMeta} location={location} />
      );
  }
};

export default HeroComponent;
